import { render } from "./MiTooltip.vue?vue&type=template&id=6cefc730"
import script from "./MiTooltip.vue?vue&type=script&lang=js"
export * from "./MiTooltip.vue?vue&type=script&lang=js"

import "./MiTooltip.vue?vue&type=style&index=0&id=6cefc730&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
